export default "https://assets-v2.scaler.com/packs/files/post-placement-nudge.1e3832.webp";